// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Stock_MovementsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for GET /so/stock/movements/{product_id}
 *
 * Returns the full stock-movement history for a product, newest first.
 * Wire shape: `dados: Stock_MovementRow[]`.
 *
 * @see Stock_MovementRow
 * @see So_stock_movements_model::listByProduct()
 */
import type { Stock_MovementRow } from './Stock_MovementRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Stock_MovementsResponseDados = Stock_MovementRow[];

export type Stock_MovementsResponse = ApiResponse<Stock_MovementsResponseDados>;

registerResponseContract('Stock_MovementsResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_stock_movement_id:            { type: 'number',  required: true },
      so_stock_movement_product_id:    { type: 'number',  required: true },
      so_stock_movement_order_item_id: { type: 'number',  required: false },
      so_stock_movement_type:          { type: 'string',  required: true },
      so_stock_movement_quantity:      { type: 'number',  required: true },
      so_stock_movement_notes:         { type: 'string',  required: false },
      so_stock_movement_user_id:       { type: 'string',  required: true },
      so_stock_movement_franchise_id:  { type: 'number',  required: true },
      so_stock_movement_location_id:   { type: 'number',  required: false },
      so_stock_movement_created_at:    { type: 'string',  required: true },
    },
  },
})
